import useCurrentOrgDetailsFetching from '@shared/hooks/useCurrentOrgDetailsFetching';
import { useParams } from 'react-router';
import { CardSmallGrid } from '../core/card/CommonCardLayouts';
import LicenseExpiredBannerCard from '../license/LicenseExpiredBannerCard';
import SplashLoader from '../loading/SplashLoader';
import OrgBillingComponents from './billing/OrgBillingComponents';
import OrgInvitesCard from './invite/OrgInvitesCard';
import LicenseKeyCard from './licenseKey/LicenseKeyCard';
import ManagedOrgCard from './managedOrg/ManagedOrgCard';
import OrgMemberCard from './member/OrgMemberCard';
import OrgProductLandingCard from './product/OrgProductLandingCard';
import OrgProjectsCard from './projects/OrgProjectsCard';
import OrgSettingsCard from './settings/OrgSettingsCard';

interface IOrgPageContentProps {
    showProjects?: boolean;
}

export default function OrgPageContent({ showProjects = false }: IOrgPageContentProps) {
    const {
        currentOrg,
        hasSomeMemberEditPermissions,
        isExpiredOrg,
        canManageBilling,
        canViewMembers,
        canInviteMembers,
        canCreateAuthClients,
        canViewOrgDetails,
        isLoading,
        canManageChildOrganizations,
    } = useCurrentOrgDetailsFetching();
    const { managedOrg } = useParams();

    if (!currentOrg) return null;
    if (isLoading) return <SplashLoader />;
    if (isExpiredOrg)
        return <LicenseExpiredBannerCard organizationId={currentOrg.id} canManageBilling={canManageBilling} />;

    if (!canViewOrgDetails) {
        return (
            <CardSmallGrid>
                <OrgBillingComponents currentOrg={currentOrg} canManageBilling={canManageBilling} />
            </CardSmallGrid>
        );
    }

    return (
        <>
            <CardSmallGrid>
                {(canViewMembers || hasSomeMemberEditPermissions) && <OrgMemberCard orgId={currentOrg.id} />}
                {canInviteMembers && <OrgInvitesCard orgId={currentOrg.id} />}
                {/* {(currentOrg.canCreateAuthClients || currentOrg.isAdmin) && (
                    <OrgMetricsCard orgId={currentOrg.organizationId} />
                )} */}
                {canCreateAuthClients && showProjects && (
                    <OrgProjectsCard orgId={currentOrg.id} projects={currentOrg.canCreateAuthClients} />
                )}
                {!managedOrg && currentOrg.isReseller && canManageChildOrganizations && (
                    <>
                        <ManagedOrgCard orgId={currentOrg.id} />
                        <LicenseKeyCard orgId={currentOrg.id} />
                        <OrgProductLandingCard orgId={currentOrg.id} />
                        {/* <OrgLicenseKeyCard orgId={currentOrg.organizationId} /> */}
                    </>
                )}
                {<OrgSettingsCard orgId={currentOrg.id} />}
            </CardSmallGrid>
        </>
    );
}
